import * as Cesium from 'cesium'
export const isDev = import.meta.env.MODE === 'development'

/**赋贴地高程 */
export async function assignHeight(
  entitis: Cesium.Entity[],
  viewer: Cesium.Viewer,
  opt?: Partial<{
    offsetY: number
  }>
) {
  const entityCartographics = entitis.map((entity) =>
    Cesium.Cartographic.fromCartesian(entity.position!.getValue()!)
  )
  let times = 3
  const getPositions: (level: number) => Promise<Cesium.Cartographic[]> = (level = 20) => {
    return Cesium.sampleTerrain(viewer.terrainProvider, level, entityCartographics, true).catch(
      () => {
        if (level <= 0) throw new Error('找不到地形')
        return new Promise((resolve) => {
          setTimeout(() => {
            if (times > 0) {
              times--
              resolve(getPositions(level))
            } else {
              times = 3
              resolve(getPositions(level - 1))
            }
          }, 100)
        })
      }
    )
  }
  const positions = await getPositions(20)
  entitis.forEach((el, i) => {
    positions[i].height += opt?.offsetY ?? 0
    el.position = new Cesium.ConstantPositionProperty(
      Cesium.Ellipsoid.WGS84.cartographicToCartesian(positions[i])
    )
  })
}
/** entity贴地 */
export async function clameToGround(entities: Cesium.Entity[], viewer: Cesium.Viewer) {
  const filterE = Array<Cesium.Entity>(),
    filterP = Array<Cesium.Cartesian3>()
  entities.forEach((el) => {
    const p = el.position?.getValue()
    if (p) {
      filterE.push(el)
      filterP.push(p)
    }
  })
  const clamps = await viewer.scene.clampToHeightMostDetailed(filterP)
  filterE.forEach((el, i) => {
    el.position = new Cesium.ConstantPositionProperty(clamps[i])
  })
}
